import { render } from "./Edit_alumium_profile.vue?vue&type=template&id=e85f9674"
import script from "./Edit_alumium_profile.vue?vue&type=script&lang=js"
export * from "./Edit_alumium_profile.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__